import {Card, Attributes, AttributesRow} from 'platform/components';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface VehicleInfoCardProps extends TestIdProps {
  title: string;
  onEditClick: () => void;
  parameters: AttributesRow[];
  isEditingDisabled?: boolean;
}

export function VehicleInfoCard(props: VehicleInfoCardProps) {
  return (
    <Card
      title={props.title}
      actions={[
        {
          type: 'button',
          variant: 'link',
          leftIcon: 'image/edit',
          onClick: props.onEditClick,
          isDisabled: props.isEditingDisabled,
          title: i18n.t('general.actions.edit'),
        },
      ]}
      data-testid={suffixTestId('header', props)}
    >
      <Attributes data-testid={suffixTestId('parameters', props)} rows={props.parameters} />
    </Card>
  );
}
